import React, { useState, useEffect, useRef } from 'react';
import { X, ChevronDown, ChevronRight } from 'lucide-react';
import AnnouncementForm from './AnnouncementForm';

import Footer from './layouts/Footer';

const SidePanel = ({ 
  isOpen, 
  onClose, 
  categories, 
  onSelectCategory, 
  selectedCategory, 
  onLogout, 
  onOpenStoreLocator, 
  isAdmin,
  isWorker,
  onViewChange,
  activeView,
  onSwitchToProducts
}) => {
  const [isProductsOpen, setIsProductsOpen] = useState(true);
  const panelRef = useRef(null);

  const toggleProductsDropdown = () => {
    setIsProductsOpen(!isProductsOpen);
  };

  const handleCategorySelect = (category) => {
    onSelectCategory(category);
    onSwitchToProducts();
    onClose();
  };





  const handleSignUpClick = () => {
  onViewChange('signup');
  onClose();
};





  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target) && isOpen) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  // Ensure "Deals" is always at the top of the categories list
  const sortedCategories = categories.includes('Deals')
    ? ['Deals', ...categories.filter(category => category !== 'Deals')]
    : categories;

  return (
    <>
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ease-in-out" 
          onClick={onClose}
        ></div>
      )}

      <div 
        ref={panelRef}
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-xl transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out flex flex-col`}
        style={{
          boxShadow: isOpen ? '4px 0 12px rgba(0, 0, 0, 0.2)' : 'none'
        }}
      >
        <div className="p-4 flex-grow overflow-y-auto">
          <button onClick={onClose} className="absolute top-4 right-4">
            <X size={24} />
          </button>
          <h2 className="text-xl font-bold mb-4">Menu</h2>
          
          {/* Admin View: Manage Products and Add Product */}
          {isAdmin && (
            <div className="mb-4">
              <button 
                onClick={() => onViewChange('products')}
                className={`block w-full text-left p-2 rounded ${activeView === 'products' ? 'bg-blue-500 text-white' : 'hover:bg-blue-100 text-blue-600'}`}
              >
                Manage Products
              </button>
              <button 
                onClick={() => onViewChange('addProduct')}
                className={`block w-full text-left p-2 rounded ${activeView === 'addProduct' ? 'bg-blue-500 text-white' : 'hover:bg-blue-100 text-blue-600'}`}
              >
                Add Product
              </button>

                  <button
            onClick={() => onViewChange('announcement')}
            className={`text-left px-4 py-2 hover:bg-green-100 w-full ${
              activeView === 'announcement' ? 'bg-green-200 font-bold' : ''
            }`}
          >
            Add Announcement
          </button>

           
  <button
    className="text-left px-4 py-2 w-full hover:bg-gray-200"
    onClick={() => onViewChange('manageAnnouncements')}

  >
    Manage Announcements
  </button>
            </div>
          )}

          {/* User and Worker View */}
          {!isAdmin && (
            <>
            
            <button
      onClick={handleSignUpClick}
      className={`block w-full text-left p-2 rounded mb-3 transition duration-200 ${
        activeView === 'signup'
          ? 'bg-green-500 text-white font-semibold shadow-md'
          : 'hover:bg-green-100 text-green-600'
      }`}
    >
      Sign Up
    </button>

              {/* Deals Category with Green Glow */}
              {sortedCategories.includes('Deals') && (
                <button 
                  onClick={() => handleCategorySelect('Deals')}
                  className={`block w-full text-left p-2 rounded transition duration-200 ease-in-out ${
                    selectedCategory === 'Deals' 
                      ? 'bg-green-500 text-white font-semibold shadow-md' 
                      : 'hover:bg-green-100 text-green-600'
                  }`}
                  style={{
                    textShadow: selectedCategory === 'Deals' 
                      ? '0 0 10px rgba(34, 197, 94, 0.8), 0 0 20px rgba(34, 197, 94, 0.6)'
                      : 'none'
                  }}
                >
                  Deals
                </button>
              )}

              {/* All Products Dropdown */}
              <div className="mb-4">
                <button 
                  onClick={toggleProductsDropdown}
                  className={`flex items-center justify-between w-full text-left p-2 rounded transition duration-200 ${
                    activeView === 'products' 
                      ? 'bg-blue-500 text-white font-semibold shadow-md' 
                      : 'hover:bg-blue-100 text-blue-600'
                  }`}
                >
                  <span>All Products</span>
                  {isProductsOpen ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
                </button>
                <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isProductsOpen ? 'max-h-96' : 'max-h-0'}`}>
                  <div className="ml-4 py-2">
                    {/* Display all categories except Deals */}
                    {sortedCategories
                      .filter(category => category !== 'Deals')
                      .map(category => (
                        <button 
                          key={category}
                          onClick={() => handleCategorySelect(category)}
                          className={`block w-full text-left p-2 rounded transition duration-200 ease-in-out ${
                            selectedCategory === category 
                              ? 'bg-blue-500 text-white font-semibold' 
                              : 'hover:bg-blue-100 text-blue-600'
                          }`}
                        >
                          {category}
                        </button>
                      ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Footer at the bottom */}
        <div className="p-4 border-t border-gray-200 mt-4">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default SidePanel;



